import type { AppState } from "./types"

export const selectScreen = (s: AppState) => s.screen
export const selectLyrics = (s: AppState) => s.lyrics
export const selectSettings = (s: AppState) => s.settings
export const selectIsPlaying = (s: AppState) => s.isPlaying
export const selectAudioFile = (s: AppState) => s.audioFile
export const selectAudioUrl = (s: AppState) => s.audioUrl
export const selectAudioDuration = (s: AppState) => s.audioDuration
export const selectBgVideoFile = (s: AppState) => s.bgVideoFile
export const selectBgVideoUrl = (s: AppState) => s.bgVideoUrl

export const selectLyricsHistory = (s: AppState) => ({
  canUndo: s.lyricsHistoryIdx > 0,
  canRedo: s.lyricsHistoryIdx < s.lyricsHistory.length - 1,
})

export const selectProjectId = (s: AppState) => s.projectId
export const selectProjectName = (s: AppState) => s.projectName
export const selectSaveStatus = (s: AppState) => s.saveStatus
export const selectLastSavedAt = (s: AppState) => s.lastSavedAt
export const selectAudioAssetId = (s: AppState) => s.audioAssetId
export const selectAudioMeta = (s: AppState) => s.audioMeta
export const selectBgVideoAssetId = (s: AppState) => s.bgVideoAssetId
export const selectCustomFontAssetId = (s: AppState) => s.customFontAssetId
export const selectThumbnailDataUrl = (s: AppState) => s.thumbnailDataUrl

export const selectBeatGrid = (s: AppState) => s.beatGrid
export const selectGridStatus = (s: AppState) => s.gridStatus
export const selectGridError = (s: AppState) => s.gridError
